import { z } from 'zod';

/**
 * Wire schemas for dietary-profile API responses (snake_case).
 * These match the Gateway response format.
 *
 * IMPORTANT: Backend stores:
 * - Timestamps as ISO string DATETIME, not Unix numbers
 * - Curated flag as a 0/1 integer, not a boolean
 * - Optional fields can be null, not just undefined
 */
export const dietaryProfileWireSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  description: z.string().nullable().optional(),
  is_curated: z.number().int(),
  created_at: z.string(), // D1 DATETIME (ISO format)
  updated_at: z.string(), // D1 DATETIME (ISO format)
});

export type DietaryProfileWire = z.infer<typeof dietaryProfileWireSchema>;

/**
 * Paginated dietary-profile response wrapper schema.
 * Mirrors createPaginatedResponseSchema from the Gateway.
 */
export const paginatedDietaryProfileResponseSchema = z.object({
  items: z.array(dietaryProfileWireSchema),
  total: z.number().int().min(0),
  page: z.number().int().min(1),
  per_page: z.number().int().min(1).max(100),
  total_pages: z.number().int().min(0),
});

export type PaginatedDietaryProfileResponseWire = z.infer<
  typeof paginatedDietaryProfileResponseSchema
>;
